import React, { useState } from "react"
import { JSONRPCErrorCatch } from "../../../error/error"
import { JSONRPCClientBuilder } from "../../../request/JSONRPCClientBuilder"
import { UserRPC } from "../../../rpcs/dist/UserRPC"
import Color from "../../../style/enum/color"
import { AuthFrame } from "../../../components/templates/auth/components/auth-frame"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { AuthWrapper } from "../signin"
import { Form } from "./form/form"
import { History } from "history"
import { IFormField } from "./form/form-meta"
import { AuthMethodLink } from "../../../components/templates/auth/components/auth-method-link"

interface IProps {
  history: History
}

const AuthMethod = "パスワードリセット"

export default (props: IProps) => {
  const [sendFinished, setSendFinished] = useState<boolean>(false)

  const submit = async (values: IFormField) => {
    const userRPC = JSONRPCClientBuilder.build(UserRPC)
    const res = await userRPC
      .sendPasswordResetInstruction({
        email: values.email,
      })
      .catch(JSONRPCErrorCatch)

    if (res !== -1) {
      setSendFinished(true)
    }
  }

  if (sendFinished) {
    return (
      <AuthWrapper>
        <AuthFrame title={AuthMethod}>
          <Description>
            <p>
              パスワードリセットメールを送信しました。
              <br />
              メールに記載されているパスワードリセット用リンクからパスワードをリセットして下さい。
            </p>
          </Description>
        </AuthFrame>
      </AuthWrapper>
    )
  }

  return (
    <AuthWrapper>
      <AuthFrame title={AuthMethod}>
        <Description>
          <p>
            登録したメールアドレスを入力してください。 <br />
            パスワードリセットの為のリンクをお送りします。
          </p>
        </Description>
        <Form onSubmit={submit} />
        <ExtendAuthMethodLink>
          <Link to={"/signin"}>ログインする</Link>
          <Link to={"/signup"}>新規登録する</Link>
        </ExtendAuthMethodLink>
      </AuthFrame>
    </AuthWrapper>
  )
}

const ExtendAuthMethodLink = styled(AuthMethodLink)`
  padding: 20px 0 0;
  margin: 20px 0 0;
  border-top: 1px solid ${Color.LIGHT_GRAY};
`

export const Description = styled.div`
  font-size: 0.8rem;
  text-align: center;
  margin: 20px 0;
  p {
    margin: 0;
  }
`
